import {MetricInfo} from "framework/entities/metricInfo";
import {getUnitType} from "areas/metrics/components/MetricSelector/utils/getUnitType";
import {MetricConfiguration, MetricConfigurationUnitType} from "areas/metrics/components/MetricSelector/types";
import {makeAutoObservable} from "mobx";
import {RemoteEventsManager} from "core/remoteEventsManager";
import {Event, MetricEvent} from "framework/entities/events";
import {
	convertMetricConfigurationsToPayload
} from "areas/metrics/components/MetricSelector/utils/convertMetricConfigurationToPayload";
import {apiFetch} from "framework/api";
import {getMetricLatestValue} from "areas/management/api";

export class MetricValueHolder {
	loaded: boolean
	loading: boolean
	error: boolean

	metrics: Record<string, MetricInfo> = {}

	subscription: any

	get metricInfo() {
		if (!this.metricConfigurations?.length || Object.keys(this.metrics).length == 0) {
			return null
		}

		const id = this.metricConfigurations[0].metricId

		return this.metrics[id]
	}

	get value() {
		if (!this.metricInfo?.data.length)
			return null

		return this.metricInfo.data[0].v
	}

	get unitType() {
		return getUnitType(this.metricConfigurations[0], this.metricInfo)
	}

	constructor(public metricConfigurations: MetricConfiguration[]) {
		makeAutoObservable(this)
	}

	async init() {
		this.loading = true

		const response = await apiFetch(getMetricLatestValue(this.metricConfigurations))
		if (response.success) {
			response.data.forEach(x => this.metrics[x.qualifier.metricId] = x)
		} else {
			this.error = true
		}

		this.loading = false
		this.loaded = true

		if (this.error)
			return

		const metrics = convertMetricConfigurationsToPayload(this.metricConfigurations)
		if (this.metricConfigurations[0].unit == MetricConfigurationUnitType.Autoscaling) {
			metrics[0].conversionUnit = this.metrics[this.metricConfigurations[0].metricId].qualifier.unitType
		}

		this.subscription = RemoteEventsManager.subscribeCallback(MetricEvent.multipleMetricSubscription({
			metrics: metrics
		}), (ev: Event) => {
			if (MetricEvent.is(ev)) {
				if (this.metrics[ev.qualifierId]) {
					Object.assign(this.metrics[ev.qualifierId].data[0], ev.metric)
				}
			}
		})

		const intervals: Record<string, number> = {}
		Object.keys(this.metrics).forEach((metricId) => intervals[metricId] = 0)

		this.subscription.releaseEvents({
			intervals
		})
	}

	destroy() {
		this.subscription?.unsubscribe()
	}
}
